import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import placeholderImg from '@/assets/Burning_Index.png'
import { burningIndexWfasInfo } from '@/constants/layers/wfasLayerInfo'

export const burningIndexNA: LayerRaw = {
  id: 'BurningIndex',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  title: {
    'en-US': 'Burning Index (BI)',
    'pt-BR': 'Índice de Quema (BI)',
    'es-ES': 'Índice de Quema (BI)',
    'fr-FR': 'Indice de gravure (BI)'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  opacity: 0.5,
  customProperties: { group: 'riskLayers', img: placeholderImg, info: burningIndexWfasInfo },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'wfas:BI_Percentiles',
      visible: true,
      legend: {
        title: {
          'en-US': 'Burning Index (BI)',
          'pt-BR': 'Índice de Quema (BI)',
          'es-ES': 'Índice de Quema (BI)',
          'fr-FR': 'Indice de gravure (BI)'
        },
        items: [
          {
            text: {
              'en-US': 'Less than 60%',
              'es-ES': 'Menos de 60%',
              'pt-BR': 'Menos de 60%',
              'fr-FR': 'Moins de 60%'
            },
            color: '#4dac26',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '60% to 79%',
              'es-ES': '60% a 79%',
              'pt-BR': '60% a 79%',
              'fr-FR': '60% à 79%'
            },
            color: '#b8e186',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '80% to 89%',
              'es-ES': '80% a 89%',
              'pt-BR': '80% a 89%',
              'fr-FR': '80% à 89%'
            },
            color: '#f7f7f7',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '90% to 96%',
              'es-ES': '90% a 96%',
              'pt-BR': '90% a 96%',
              'fr-FR': '90% à 96%'
            },
            color: '#f1b6da',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '97%+',
              'es-ES': '97%+',
              'pt-BR': '97%+',
              'fr-FR': '97%+'
            },
            color: '#d01c8b',
            icon: 'mdi-square'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
}
